import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "section section-collection army" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "row cards" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "section-hero-bubbles army-animateon" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_army_stats_container = _resolveComponent("army-stats-container")!
  const _component_your_squades_container = _resolveComponent("your-squades-container")!
  const _component_new_cybersquad_blocks_container = _resolveComponent("new-cybersquad-blocks-container")!
  const _component_user_soldiers = _resolveComponent("user-soldiers")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createVNode(_component_army_stats_container),
        _createVNode(_component_your_squades_container),
        _createVNode(_component_new_cybersquad_blocks_container),
        _createVNode(_component_user_soldiers)
      ])
    ])
  ]))
}